module.exports = __webpack_public_path__ + "img/monitoring-truck-selected.3f39fafd.svg";